import React from 'react';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/booking-embed.css';

const BookAerialPage = () => {
  return (
    <div className="booking-embed-page">
      <div className="booking-embed-header">
        <Link to="/aerial" className="back-link">
          <ArrowLeft size={20} />
          Back to Aerial Kids
        </Link>
        <h1 className="booking-embed-title">Book Kids Aerial Arts + Fitness Adventures</h1>
        <p className="booking-embed-subtitle">
          Register your child for classes, camps, and aerial adventures.
        </p>
      </div>

      <div className="booking-embed-container jotform-container" data-testid="jotform-embed-container">
        <iframe
          id="JotFormIFrame-252416529351153"
          title="GOCALFIT AERIAL KIDS Registration Form"
          allowtransparency="true"
          allow="geolocation; microphone; camera; fullscreen; payment"
          src="https://pci.jotform.com/form/252416529351153"
          frameBorder="0"
          className="booking-embed-iframe jotform-iframe"
        />
      </div>

      <div className="booking-embed-fallback">
        <p>Having trouble?</p>
        <a 
          href="https://pci.jotform.com/form/252416529351153" 
          target="_blank" 
          rel="noopener noreferrer"
          className="fallback-link"
        >
          Open registration form in a new tab
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
  );
};

export default BookAerialPage;
